import httpService from '../Api/http.service';

const SUPPORTED_COUNTRIES_PATH = '/mgt/supported-countries';

/**
 * Fetches supported country codes from the API (e.g. for login prefill by IP).
 * @returns {Promise<string[]>} List of country codes, or [] on error/empty
 */
const getSupportedCountryCodes = async () => {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL_V2 || "https://api.subscribili.com";
    const response = await httpService({
      url: `${baseUrl}${SUPPORTED_COUNTRIES_PATH}`,
      method: 'get',
    });
    const codes = response?.data?.country_codes || [];
    return Array.isArray(codes) ? codes : [];
  } catch (error) {
    console.error('Error fetching supported countries:', error);
    return [];
  }
};

const supportedCountriesService = {
  getSupportedCountryCodes,
};

export default supportedCountriesService;
